
export enum FilterTypesEnum {
    checkboxes = 'checkboxes',
    radio = 'radio',
    text = 'text',
    autocomplete = 'autocomplete',
    range = 'range',
    duplicates = 'duplicates',
    dateQuery = 'dateQuery',
    group = 'group',
    keyword = 'keyword',
    custom = 'custom',
    singleText = 'singleText',
}
